import {AxiosInstance, AxiosResponse} from 'axios';
import {
    MemberRegistrationRepository,
    ResetRegistrationCodeResponse
} from '@/model/repository/manager/members/MemberRegistrationRepository';

export default (Repository: AxiosInstance) =>
    (resource: string): MemberRegistrationRepository => ({
        resetRegistrationCode(id): Promise<AxiosResponse<ResetRegistrationCodeResponse>> {
            const endpoint = resource.replace('{id}', id);
            return Repository.post(endpoint);
        },
    });
